var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.project.id)?_c('project-modal',{attrs:{"project":_vm.project},on:{"refresh":_vm.refresh}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }